"use client";

import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { formatDocumentTitle, resolvePageTitle } from "@/lib/pageTitle";

/**
 * 現在のルートに応じて document.title を設定する。
 * タイトルは lib/pageTitle.ts の「ルートパターン → タイトル」対応表で
 * 中央管理する（ページ側の変更なしで全画面に効く）。
 *
 * 個別ページでより具体的なタイトル（例: イベント名）を出したい場合は、
 * そのページで <Helmet><title>...</title></Helmet> を書けば
 * こちらより深い位置の Helmet が優先されて上書きできる。
 */
export function DocumentTitle() {
  const { pathname } = useLocation();
  const title = formatDocumentTitle(resolvePageTitle(pathname));
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
}
